import { r as s } from "./client-BkmPNNjT.mjs.js";
const C = (t) => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), f = (t) => t.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (e, r, o) => o ? o.toUpperCase() : r.toLowerCase()
), i = (t) => {
  const e = f(t);
  return e.charAt(0).toUpperCase() + e.slice(1);
}, l = (...t) => t.filter((e, r, o) => !!e && e.trim() !== "" && o.indexOf(e) === r).join(" ").trim(), h = (t) => {
  for (const e in t)
    if (e.startsWith("aria-") || e === "role" || e === "title")
      return !0;
};
var w = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const g = s.forwardRef(
  ({
    color: t = "currentColor",
    size: e = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: o,
    className: n = "",
    children: a,
    iconNode: p,
    ...c
  }, u) => s.createElement(
    "svg",
    {
      ref: u,
      ...w,
      width: e,
      height: e,
      stroke: t,
      strokeWidth: o ? Number(r) * 24 / Number(e) : r,
      className: l("lucide", n),
      ...!a && !h(c) && { "aria-hidden": "true" },
      ...c
    },
    [
      ...p.map(([d, m]) => s.createElement(d, m)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
const k = (t, e) => {
  const r = s.forwardRef(
    ({ className: o, ...n }, a) => s.createElement(g, {
      ref: a,
      iconNode: e,
      className: l(
        `lucide-${C(i(t))}`,
        `lucide-${t}`,
        o
      ),
      ...n
    })
  );
  return r.displayName = i(t), r;
};
const b = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], x = k("x", b);
export {
  x as X,
  k as c
};
